import moment from 'moment';

//Redux-form is missing something, since we are not receiving previousValue
export const r_maxLength = (expectedLen) => (value) => {
  //value === null ? null : value === '' || value.length <= expectedLen ? value : previousValue;
  let newVal = value || '';
  return newVal.length <= expectedLen ? newVal : newVal.slice(0, expectedLen);
};

export const r_phoneNumber = (length) => {
  let maxLength = r_maxLength(length);
  return (value, prev) => maxLength(/^$|^[0-9]+$/g.test(value || '') ? value : prev, prev);
};

export const validateFile = (validateFor, limit) => {
  return (value, prev) => {
    if (value) {
      let size = value.size;
      if (value) {
        let isInvalidFile = validateFor.includes(`image/${value.type}`);

        if (isInvalidFile) {
          return prev;
        } else if (size && limit) {
          if (size / 1000 / 1000 > limit) {
            return prev;
          } else {
            return value;
          }
        }
      }
    }
  };
};

export const r_maxLengthWith2DigitsAfterDecimal = (expectedLen) => (value) => {
  //accept only string if not convert it into the string
  if (value && typeof value !== 'string') value = value.toString();

  //allow digits having expected length with excluding the decimal
  if (value && value.indexOf('.') > -1 && value.indexOf('.') > expectedLen) {
    if (value.indexOf('.') > expectedLen) {
      return value.substring(0, expectedLen);
    } else {
      return value.substring(0, expectedLen + 2);
    }
  } else if (value && value.indexOf('.') === -1 && value.length > expectedLen - 1) {
    return value.substring(0, expectedLen);
  }
  //if the input value is not a number then return zero
  const indexOfDot = value.indexOf('.');
  if (!value || isNaN(Number(value))) {
    return '';
  } else if (indexOfDot > -1 && value.length - indexOfDot > 3) {
    return value.substring(0, indexOfDot + 3);
  }
  return value;
};

export const maxValueUptoTwoDecimal = (expectedLen) => (value, previousValue) => {
  if (value < 2000000) {
    //accept only string if not convert it into the string
    if (value && typeof value !== 'string') value = value.toString();

    //allow digits having expected length with excluding the decimal
    if (value && value.indexOf('.') > -1 && value.indexOf('.') > expectedLen) {
      if (value.indexOf('.') > expectedLen) {
        return value.substring(0, expectedLen);
      } else {
        return value.substring(0, expectedLen + 2);
      }
    } else if (value && value.indexOf('.') === -1 && value.length > expectedLen - 1) {
      return value.substring(0, expectedLen);
    }
    //if the input value is not a number then return zero
    const indexOfDot = value.indexOf('.');
    if (!value || isNaN(Number(value))) {
      return '';
    } else if (indexOfDot > -1 && value.length - indexOfDot > 3) {
      return value.substring(0, indexOfDot + 3);
    }
    return value;
  } else {
    return previousValue;
  }
};

export const r_onlyNumbers = (value, previousValue) => {
  return /^[0-9]*$/gi.test(value) ? value : previousValue;
};

export const r_mobileNumber = (value, previousValue) => {
  if (value && value.slice(0) === '0') {
    return previousValue;
  }
  return /^[0-9]*$/gi.test(value) ? value : previousValue;
};

export const r_onlyCaps = (value) => {
  return value.toUpperCase();
};

export const r_lessThan = (lesthan) => (value, previousValue) =>
  Number(value) <= lesthan ? value : previousValue;

export const r_greaterThan = (lesthan) => (value, previousValue) =>
  Number(value) <= lesthan ? value : previousValue;

export const no_spaces = (value, previousValue) => {
  if (value) {
    return value.indexOf(' ') < 0 ? value : previousValue;
  }
  return value;
};

export const r_password = (value, previousValue) => {
  let expression = /[A-Za-z0-9*%@#$^]$/;

  if (expression.test(value)) {
    return value;
  } else {
    return previousValue;
  }
};

export const r_upperCase = (value) => value && value.toUpperCase();

export const isValidDateFormat = (value, previousValue) => {
  if (value && !value.isValid()) {
    return moment(previousValue).format('DD/MM/YYYY');
  }
  return moment(value).format('DD/MM/YYYY');
};

export const normalizeAll = (normalizers) => {
  return function (value, previousValue, allValues, previousAllValues) {
    //note that these arguments are passed by default from redux form
    let i = 0;
    let normalizersLength = normalizers.length;
    let currentValue = value;
    while (i < normalizersLength) {
      let currentNormalizer = normalizers[i];
      if (typeof currentNormalizer === 'function') {
        currentValue = currentNormalizer(currentValue, previousValue, allValues, previousAllValues);
      }
      i++;
    }

    return currentValue;
  };
};

export const r_alphaNumeric = (value, previousValue) =>
  /^$|^[a-zA-Z0-9]*$/i.test(value || '') ? value : previousValue;

export const normalizeCurrency = (value, previousValue) => {
  if (!value) return 0;
  if (isNaN(value) || value < 0) return previousValue;
  if (/\s/g.test(value)) return previousValue;
  let fractionLength = value
    .toString()
    // eslint-disable-next-line
    .replace(new RegExp(`\(\.\*\(\?\=\\\.\)\.\)|${value}`, 'g'), '').length;
  if (fractionLength > 2) return previousValue;
  if (value.length > 10) {
    /*
    this is case where, currency value is greater than 10 digits and it shows all those digits. 
    While user tries to changes more that 10 digits.
    value, then we substring it upto 10 digits before the decimal point if decimal point is present.
    */
    previousValue = previousValue.toString();
    previousValue = previousValue.substring(0, previousValue.charAt('.') + 1);
    previousValue = previousValue.substring(0, 10);
    return previousValue;
  }
  return value;
};

export const dynamic_normalizer = (restrictions) => {
  return function (value, previousValue) {
    let val = value;
    if (restrictions) {
      restrictions.forEach((key) => {
        switch (key) {
          case 'r_onlyNumbers':
            val = r_onlyNumbers(value, previousValue);
            break;
          case 'r_onlyCaps':
            val = r_onlyCaps(value);
            break;
          default:
            val = value;
        }
      });
    }
    return val;
  };
};
